import React, {PropTypes,Component}  from 'react';
import './CustomDate.less';
import Icon from '../Icon';
import {autobind} from 'core-decorators';
var mobx = require('mobx');


const preventEvent = (event) => {
    if (event) {
        event.preventDefault();
        event.stopImmediatePropagation && event.stopImmediatePropagation();
        event.stopPropagation();
    }
};

class CustomDate extends Component {
  // static PropTypes = {
  //      startDate: React.PropTypes.string,
  //      endDate: React.PropTypes.string,
  //      preStartDate: React.PropTypes.string,
  //      preEndDate: React.PropTypes.string,
  //      dateChoose: React.PropTypes.func,
  //      dateQuery: React.PropTypes.dateQuery
  // }

  constructor(props, context) {
     super(props, context);
     const {startDate='',endDate='',preStartDate='',preEndDate=''} = this.props;
     this.state = {
       startDate: startDate,
       endDate: endDate,
       preStartDate:preStartDate,
       preEndDate:preEndDate
     };
  }

  componentWillReceiveProps(nextProps) {
    const {startDate='',endDate='',preStartDate='',preEndDate=''} = nextProps;
    this.state = {
      startDate: startDate,
      endDate: endDate,
      preStartDate:preStartDate,
      preEndDate:preEndDate
    };
  }

   @autobind
   handleDateChoose(dateKey,event) {
     const {dateChoose} = this.props;
     preventEvent(event);
     dateChoose(dateKey);
   }

   @autobind
   query(event){
     preventEvent(event);
     const {dateQuery} =  this.props;
     dateQuery();
   }

  //  postDateChoose(dateKey,dateValue){
  //    const {dateChoose} = this.props;
  //    let newState = this.state;
  //    newState[dateKey] = dateValue;
  //    this.setState(newState);
  //    dateChoose(dateKey,dateValue);
  //  }

  render (){
    const{isMoreCustomDate} = this.props;
    let startDateLabel = this.state.startDate?this.state.startDate:'开始时间';
    let endDateLabel = this.state.endDate?this.state.endDate:'结束时间';

    let preStartDateLabel = this.state.preStartDate?this.state.preStartDate:'上期开始';
    let preEndDateLabel = this.state.preEndDate?this.state.preEndDate:'上期结束';

    let titleStyle = {padding:'0',paddingRight:'0.1rem',fontSize:'0.4rem'};

    return(
      <div className="dateArea">
        <div className="date">
        <div>
           {isMoreCustomDate && <span style = {titleStyle}>本期:</span>}
           <p onClick={this.handleDateChoose.bind(this,'startDate')}><span>{startDateLabel}</span></p>
           <span>至</span>
           <p onClick={this.handleDateChoose.bind(this,'endDate')}><span>{endDateLabel}</span></p>
        </div>
        {isMoreCustomDate && <div style={{marginTop: '0.3rem'}}>
           {isMoreCustomDate && <span style = {titleStyle}>上期:</span>}
           <p onClick={this.handleDateChoose.bind(this,'preStartDate')}><span>{preStartDateLabel}</span></p>
           <span>至</span>
           <p onClick={this.handleDateChoose.bind(this,'preEndDate')}><span>{preEndDateLabel}</span></p>
        </div>}
        </div>
        <div onClick={this.query} className="lookupButton" >确定</div>
      </div>
    );
  }

}
export default CustomDate;
